import Icon, { IconTypes } from "shared/ui/icon";
import { RightArrow } from "shared/ui/icons/RightArrow";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

const pdfMapping: { [key: string]: string } = {
  opdekdeur:
    "https://gewoongers.nl/storage/pdfjes/inmeetdocument_opdekdeur_in_bestaand_kozijn.pdf",
  taatsdeur: "https://gewoongers.nl/storage/pdfjes/gg_inmeten_taatsdeur.pdf",
  schuifdeur: "https://gewoongers.nl/storage/pdfjes/gg_inmeten_schuifdeur.pdf",
};
const SelfInstallmentWarning = ({ selectedDoor }: { selectedDoor: string }) => {
  const instructionsLink = pdfMapping[selectedDoor];
  const informationLink =
    "https://gewoongers.nl/faq/verschil-opdekdeur-en-stompe-deur";

  return (
    <div
      className={concatClassnames(
        "gg-w-full gg-rounded-sm gg-border gg-bg-grey-500 sm:gg-w-fit lg:gg-w-full",
        "gg-mt-3 gg-flex gg-max-w-2xl gg-items-start gg-border-grey-200 gg-pb-6 gg-pl-[18px] gg-pr-[16px] gg-pt-5",
      )}
    >
      <div>
        <div className="gg-flex">
          <div>
            <Heading headingLevel="h4" className="gg-mb-2">
              Zelf monteren
            </Heading>

            <Text
              data-testid="self-assembly-text"
              className="gg-mb-5 gg-text-sm"
            >
              Ga je je bestelling zelf monteren? Vinden we Gers! Hou er rekening
              mee dat je de maten van jouw gewenste deur correct inmeet. Hoe je
              dat doet kun je hier terugvinden:
            </Text>
          </div>

          <div className="gg-ml-4 gg-h-fit gg-shrink-0 gg-bg-yellow gg-p-3">
            <Icon
              name={IconTypes.MEASUREMENT}
              className="gg-h-6 gg-w-6 gg-rounded-sm"
            />
          </div>
        </div>

        <a
          href={instructionsLink}
          target="_blank"
          className="gg-flex gg-items-center gg-gap-x-2.5 gg-pb-1 gg-text-xs gg-font-bold gg-underline gg-underline-offset-2 hover:gg-text-gray-600 sm:gg-text-sm sm:gg-underline-offset-4 xl:gg-underline-offset-8"
          rel="noreferrer"
        >
          Bekijk inmeetinstructies
          <RightArrow width={14} height={12} />
        </a>
        {selectedDoor === "opdekdeur" && (
          <a
            href={informationLink}
            target="_blank"
            className="gg-mt-3 gg-flex gg-items-center gg-gap-x-2.5 gg-pb-1 gg-text-xs gg-font-bold gg-underline gg-underline-offset-2 hover:gg-text-gray-600 sm:gg-text-sm sm:gg-underline-offset-4 xl:gg-underline-offset-8"
            rel="noreferrer"
          >
            Verschil tussen opdekdeur en stompe deur
            <RightArrow width={14} height={12} />
          </a>
        )}
      </div>
    </div>
  );
};
export default SelfInstallmentWarning;
